"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden lg:flex gap-1">
        <div className="h-9 w-16 bg-secondary animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-secondary animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-secondary animate-pulse rounded-md" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden lg:flex">
        <NavigationMenuList className="gap-1">
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="relative px-4 py-2 text-sm font-medium text-foreground hover:!bg-transparent focus:!bg-transparent transition-colors duration-300 group">
                  {item.label}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 ease-out group-hover:w-full" />
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="lg:hidden hover:!bg-transparent focus:!bg-transparent" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {}
      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background border-b border-border lg:hidden shadow-medium z-50">
          <nav className="container mx-auto px-4 py-4 flex flex-col gap-2">
            {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="px-4 py-3 text-sm font-medium text-foreground hover:bg-secondary rounded-md transition-colors duration-200" onClick={() => setMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="header" className={`dark bg-background text-foreground fixed top-0 left-0 right-0 z-50 border-b border-border transition-all duration-300 ${scrolled ? "h-16 backdrop-blur-md bg-background/90" : "h-22"}`}>
      <div className="container mx-auto px-8 h-full flex items-center justify-between">
        {}
        <Link to="/HomePage#" className="flex-shrink-0 hover:opacity-90 transition-opacity">
          <img src="https://aware-ocelot.10web.cloud/wp-content/uploads/2026/02/logo.png" alt="FAKTA INTEGRITAS" className="!w-[100px] !h-[70px]" />
        </Link>

        {}
        <MenuProvider menu_id="3" className="flex-1 flex justify-center">
          <HeaderMenuConsumer />
        </MenuProvider>

        {}
        <Button asChild className={`hidden lg:inline-flex hover:!bg-primary-hover focus:!bg-primary-hover transition-all duration-300 ${scrolled ? "px-4 py-2 text-sm" : "px-6 py-3"}`}>
          
        </Button>
      </div>
    </header>;
}